module.exports = __webpack_public_path__ + "img/CCDashDecentW00-Heavy.0c830f45.svg";